import loginLogoDefault from '../../assets/images/landing-title-long.png';
import loginLogoJaq from '../../assets/images/JAQ_Final.png';
import loginBackgroundDefault from '../../assets/images/background.jpg';
import loginBackgroundJaq from '../../assets/images/jaq-background.jpg';
import psiLogoDefault from '../../assets/images/PSI-logo.png';
import psiLogoJaq from '../../assets/images/PSI_Final.png';
import poweredByTextDefault from '../../assets/images/powered-by-text-for-home-screen.png';
import poweredByTextJaq from '../../assets/images/powered-by-text-blue.png';
import headerLogoJaq from '../../assets/images/JAQ-dkblue-logo.png';
import { titleLogoJAQ, titleLogoPSI } from '../constants/faviconConstants';
import headerLogoATAI from '../../assets/images/atai-header-gold.png';
import titleLogoATAI from '../../assets/images/atai-gold.png';
interface IAssetMap {
    loginBackground: any,
    loginLogo: any,
    loginLowerLeft: any,
    loginLowerRight: any,
    headerLogo: any,
    titleLogo: any,
    appTitle: string,
}

type AssetKey =
    'loginBackground' |
    'loginLogo' |
    'loginLowerLeft' |
    'loginLowerRight' |
    'headerLogo' |
    'titleLogo' |
    'appTitle';

export const assetMap = (assetKey: AssetKey) => {
    const env = process.env.REACT_APP_SKIN_NAME || 'default';
    let envAssets: IAssetMap | undefined;
    switch (env) {
        case 'jaq': {
            envAssets = {
                loginBackground: loginBackgroundJaq,
                loginLogo: loginLogoJaq,
                loginLowerLeft: psiLogoJaq,
                loginLowerRight: poweredByTextJaq,
                headerLogo: headerLogoJaq,
                titleLogo: titleLogoJAQ,
                appTitle: 'JAQ'
            }
            break;
        }
        case 'atai': {
            envAssets = {
                loginBackground: loginBackgroundJaq,
                loginLogo: headerLogoATAI,
                loginLowerLeft: psiLogoJaq,
                loginLowerRight: poweredByTextJaq,
                headerLogo: headerLogoATAI,
                titleLogo: titleLogoATAI,
                appTitle: 'ATAI'
            }
            break;
        }
        default : {
            envAssets = {
                loginBackground: loginBackgroundDefault,
                loginLogo: loginLogoDefault,
                loginLowerLeft: psiLogoDefault,
                loginLowerRight: poweredByTextDefault,
                headerLogo: undefined, // this is defined as a text string in the Header component.
                titleLogo: titleLogoPSI,
                appTitle: 'PSI Checkmate'
            }
        }
    }
    return envAssets[assetKey];
}